import React, { useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";
import { useWsNavigate } from "../../hooks/useWsNavigate";
import { usePageTitle } from "../../contexts/PageTitleContext";
import { useAgent } from "../../contexts/AgentContext";
import AgentPicker from "../../components/AgentPicker";
import AlertsSettings from "../../components/settings/AlertsSettings";

const Alerts = () => {
  const { setPageTitle, setParentPage, setShowBackButton } = usePageTitle();
  const { id } = useParams();
  const location = useLocation();
  const navigate = useWsNavigate();
  // Agent picker lives inline on the page (not the top bar), matching the other
  // observability pages. The shared agent context drives the selection.
  const { agents, selectedAgent, setSelectedAgent } = useAgent();

  // Route drives the mode, the same way /ai-testing-agent vs /ai-testing-agent/create do:
  //   /observability/notifications            → list
  //   /observability/notifications/new         → create form
  //   /observability/notifications/:id/edit    → edit form
  const mode = id ? "edit" : location.pathname.endsWith("/new") ? "new" : "list";
  const editId = id ? parseInt(id, 10) : null;

  // List is a top-level page; new/edit are nested sub-pages that show a breadcrumb
  // (← Notifications › …) in the layout title bar, matching /evaluation/custom-metrics.
  useEffect(() => {
    setPageTitle(mode === "list" ? "Notifications" : mode === "edit" ? "Edit Notification Rule" : "New Notification Rule");
    if (mode === "list") {
      setParentPage(null);
      setShowBackButton(false);
    } else {
      setParentPage({ name: "Notifications", href: "/observability/notifications" });
      setShowBackButton(true);
    }
    return () => {
      setPageTitle(null);
      setParentPage(null);
      setShowBackButton(false);
    };
  }, [setPageTitle, setParentPage, setShowBackButton, mode]);

  const agentPicker =
    agents.length > 0 ? (
      <AgentPicker
        agents={agents}
        selectedAgent={selectedAgent}
        setSelectedAgent={setSelectedAgent}
        onAdd={() => navigate("/ai-testing-agent/create")}
      />
    ) : null;

  return (
    <div className="px-4">
      <AlertsSettings selectedAgent={selectedAgent} agentPicker={agentPicker} mode={mode} editId={editId} />
    </div>
  );
};

export default Alerts;
